<template>
  <div v-if="invoice" class="modal" :class="{active: show}">
    <a class="modal-overlay" @click="close"></a>
    <div class="modal-container">

      <div class="modal-header">
        <a @click="close" class="btn btn-clear float-right" aria-label="Close"></a>
        <div class="modal-title h5">Send invoice</div>
      </div>


      <div class="modal-body">
        <div class="content">

          <div class="form-group">
            <label class="form-label" for="input-example-3">Message</label>
            <quillEditor id="editor" v-model="message" :options="editorOptions" />
          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button class="btn" @click.prevent="send" :class="{loading: sending}">Send</button>
        <span v-if="sendError" class="label label-error">Something went wrong</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'sendInvoiceModal',
  props: ['show', 'invoice'],
  components: { quillEditor },
  data () {
    return {
      sending: false,
      sendError: false,
      message: '',
      editorOptions: {
        theme: 'bubble'
      }
    }
  },
  watch: {
    invoice () {
      this.updateMessage()
    }
  },
  methods: {
    updateMessage () {
      let inv = this.invoice
      if (!inv) return
      let link = [window.location.origin, '/#/invoices/', inv._id].join('')
      let brand = null

      if (inv.brand && inv.brand === 'ie') {
        brand = 'Immigration Experts'
      } else {
        brand = 'PocketLegal'
      }

      this.message = [
        '<p>Hi ', inv.firstname, ',</p>',
        '<p>We have prepared an invoice for you, which you will find attached to this email.</p>',
        '<p>You can pay online via the link below.</p>',
        '<p><a href=\'', link, '\' target=\'_blank\'>Online payment</a></p>',
        '<p>Regards,<br>', brand, ' Accounts</p>'].join('')
    },
    close () {
      this.$emit('close')
    },
    send () {
      this.sending = true
      this.sendError = false
      axios.post('/api/invoices/send', {
        invoiceId: this.invoice._id,
        message: this.message
      })
      .then(res => {
        if (res.status === 200) {
          this.sending = false
          this.invoice.sent = true
          this.$emit('done')
        }
      })
      .catch(e => {
        this.sending = false
        this.sendError = true
        console.log(e.response.data)
      })
    }
  }
}
</script>

<style scoped>
#editor {
  border: .05rem solid #caced7;
  border-radius: .1rem;
}
.modal-footer .btn {
  background: #136efb!important;
  border-color: #136efb!important;
  color: #fff
}
.modal-footer .btn.loading::after {
  border-bottom-color: #fff;
  border-left-color: #fff;
}
</style>



// WEBPACK FOOTER //
// sendInvoiceModal.vue?eefecc78